import _, { Dictionary } from 'lodash';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ApplicationModel } from 'src/redux/actions/applications.action';
import { getSignedInEmployeeList } from 'src/redux/actions/employee-reports.action';
import { List } from 'src/shared/components';
import { configurationConstants } from 'src/shared/constants/configuration.constants';
import {
  NotSignedInEmployeeReport,
  SignedInEmployee,
} from 'src/shared/models/employee-reports.model';
import { getListFieldsByConfiguration } from 'src/shared/utils/configuration.util';

interface Props {
  signedInUsersReports: SignedInEmployee[];
  application: ApplicationModel;
  getSignedInEmployeeList: (appId: string) => void;
}

const SignedInUsersReports: FC<Props> = ({
  signedInUsersReports,
  application,
  getSignedInEmployeeList,
}) => {
  const { t } = useTranslation();
  const { appId } = useParams<{ appId: string }>();
  const [grouped, setGrouped] = useState<Dictionary<NotSignedInEmployeeReport[]>>();

  useEffect(() => {
    getSignedInEmployeeList(appId);
  }, [appId, getSignedInEmployeeList]);

  useEffect(() => {
    setGrouped(_.groupBy(signedInUsersReports, 'groupByName'));
  }, [signedInUsersReports]);

  const configuredFields = useMemo(() => {
    return getListFieldsByConfiguration(
      application,
      configurationConstants.hropsEmployeeSignedInListList,
      t,
    );
  }, [application, t]);

  return (
    <div className="animated fadeIn">
      {grouped &&
        Object.entries(grouped).map(([key, value]) => (
          <div key={key}>
            <h2>{key}</h2>
            <List
              hidePager
              data={value}
              totalElements={value.length}
              loaded={configuredFields !== undefined}
              loading={configuredFields === undefined}
              noDataLabel={t('employeeReports.noData')}
              fetchData={() => {}}
              fields={configuredFields}
            />
          </div>
        ))}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    signedInUsersReports: state.employeeReports.data.signedInUsersReports,
  };
};

const mapDispatchToProps = {
  getSignedInEmployeeList,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignedInUsersReports);
